import React from "react";

export const CompanyLoadTooltip = ({ x, y, visible, companyLoadData }) => {
    if (!visible || !companyLoadData) return null;

    const { pickupDate, loadId, price, broker } = companyLoadData;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const formattedDate = `${monthNames[pickupDate.month - 1]}, ${pickupDate.day}`;

    const formattedRate = `$ ${new Intl.NumberFormat("en-US").format(Math.round(price))}`;

    const hasBroker = Boolean(broker);

    return (
        <div
            className="absolute bg-cm-p-surface shadow-lg rounded-[5px] py-2 px-3 pointer-events-none z-10 border border-cm-p-outline"
            style={{
                left: x,
                top: y,
                transform: "translateY(-50%)",
                minWidth: 180,
                height: hasBroker ? 128 : 101,
            }}
        >
            <div className="flex flex-col gap-2 text-cm-p-text-primary">
                <div className="flex justify-between gap-4 leading-[19px] text-xs">
                    <span>Pickup</span>
                    <span>{formattedDate}</span>
                </div>
                <div className="flex justify-between gap-4 leading-[19px] text-xs">
                    <span>Load ID</span>
                    <span>{loadId || "N/A"}</span>
                </div>
                {hasBroker && (
                    <div className="flex justify-between gap-4 leading-[19px] text-xs">
                        <span>Broker</span>
                        <span>{broker}</span>
                    </div>
                )}
                <div className="w-full h-[1px] bg-cm-p-outline" />
                <div className="flex justify-between gap-4 leading-[22px] text-sm font-medium">
                    <span>Rate</span>
                    <span>{formattedRate}</span>
                </div>
            </div>
        </div>
    );
};
